import { qualifyUrls } from "routing/Routes";
const IlluminateRoutes = {
  LIST: "/illuminate",
  CUSTOMIZATION: "/illuminate/customize",
  CUSTOMIZATION_DETAILS: (id) => `/illuminate/customize/${id}`,
  INSTALL: "/illuminate/install"
};
const routes = qualifyUrls(IlluminateRoutes);
export default {
  ...routes,
  unqualified: IlluminateRoutes
};
